/**
 *
 * Mobile kudago app setup.
 *
 */

// add polyfill for the old browsers
// eslint-disable-next-line max-classes-per-file
require('./polyfill');

const moment = require('moment');
require('moment/locale/ru');

moment.locale(window.kudago.language);

const React = require('react');
const ReactDOM = require('react-dom');
const q = require('queried');
const queryString = require('query-string');
const Swiper = require('swiper');
const delegate = require('emmy/delegate');
const on = require('emmy/on');
const emit = require('emmy/emit');
const shuffle = require('lodash/shuffle');
const fromPairs = require('lodash/fromPairs');
const { v4: uuidv4 } = require('uuid');
const autosize = require('autosize');
const ajax = require('component-ajax');
const likely = require('ilyabirman-likely');
const cookie = require('cookie-cutter');
const dialog = require('dialog-component');
const css = require('mucss/css');
const stickybits = require('stickybits');
const echoFactory = require('echo-js');
const phrases = require('./components/phrases');
const _ = require('./components/i18n');
const ImageLazyLoader = require('./components/imagelazyloader');
const kudago = require('./components/kudago');
const Subscription = require('./components/subscription');
const AdvertButton = require('./components/advert-button');
const CollapseTags = require('./components/collapse-tags');
const Faq = require('./components/faq');
const FlipCard = require('./components/flip-card');
const {
  wrapInRaven,
  scrollToEl,
  sortItemFeaturedItems,
  isSafari,
  setBodyFixed,
  inlineSvg,
  getUserCoords,
  initTabs,
  collapseUncollapseDetails,
} = require('./components/utils');
const getUserConfig = require('./components/get-user-config');
const VotingList = require('./components/award');
const PageRating = require('./components/rating');
const ListItemAddressList = require('./components/list-item-address-list');

const feedbackFormHendler = require('./components/feedback-form-handler');
const Quiz = require('./components/quiz');
const MiniQuiz = require('./components/mini-quiz');
const MiniQuestion = require('./components/mini-question');

require('./components/self-service');

phrases.setLocale(kudago.language);
kudago.mobile = true;

// Privet, remove me after elastica will be ok

collapseUncollapseDetails('multi-rows-container', '.multi-rows-item');

wrapInRaven(() => {
  kudago.user = getUserConfig();

  q.all('.body--votingPage').forEach((feed) => new VotingList(feed));

  const stextMixMobileBlock = document.querySelector('.mix-stext-mobile');
  const subscriptionEl = document.querySelector('#subscription-block');

  if (stextMixMobileBlock && subscriptionEl) {
    stextMixMobileBlock.remove();
    const stextMixMobileBlockClone = stextMixMobileBlock.cloneNode(true);
    stextMixMobileBlockClone.style.order = 'unset';
    subscriptionEl.after(stextMixMobileBlockClone);
  }

  /* --------- item featured items rotation --------- */
  const featuredItemsSlider = q('.featured-slider');

  if (featuredItemsSlider) {
    const featuredItems = q.all('.fs-item', featuredItemsSlider);

    const itemsToRemove = sortItemFeaturedItems(featuredItems)
    // we obtain array arrays f. items sorted by position,
    // and then take randomely 1 item from each position and
    // remove the rest, when show and initialize swiper on them
      .map((list) => shuffle(list).slice(1));
    itemsToRemove.forEach((list) => {
      if (list.length) {
        list.forEach((element) => element.closest('.swiper-slide').remove());
      }
    });
    q.all('.swiper-slide', featuredItemsSlider).forEach((item) => {
      item.classList.remove('hidden');
    });
  }

  if (isSafari(navigator.userAgent)) {
    document.body.classList.add('body--safari');
  }

  const flipCardContainer = q('.container-flipcard');
  if (flipCardContainer) {
    const FlipCardObj = new FlipCard();
    FlipCardObj.start();
  }

  const showMoreTagButton = q('.collapse-tag-show');
  if (showMoreTagButton) {
    const Collapse = new CollapseTags();
    Collapse.start();
  }

  const faqBlocks = q('.faq-wrapper');
  if (faqBlocks) {
    const FaqEl = new Faq();
    FaqEl.start();
  }

  /* --------- remove vk sign up | log in --------- */
  if (kudago.page === 'award') {
    const vkButtonsLogIn = document.querySelectorAll('.authPopup-vk');
    if (vkButtonsLogIn.length > 0) {
      vkButtonsLogIn.forEach((button) => {
        button.remove();
      });
    }
  }

  const echo = echoFactory(window);
  echo.detach();
  echo.init({
    offset: 100,
    throttle: 250,
    unload: false,
    callback(elem, op) {
      elem.setAttribute('data-echo-loaded', op == 'load');
    },
  });

  const showMoreHarnessButton = document.querySelector('.harness-show_all');
  if (showMoreHarnessButton) {
    showMoreHarnessButton.addEventListener('click', () => {
      const elementsHide = document.querySelectorAll('.post-harness .harness-item_hide');
      elementsHide.forEach((el) => { el.style.display = 'block'; });
      showMoreHarnessButton.style.display = 'none';
      document.querySelector('.harness_hide').style.display = 'block';
    });
    document.querySelector('.harness_hide').addEventListener('click', () => {
      const elementsHide = document.querySelectorAll('.post-harness .harness-item_hide');
      elementsHide.forEach((el) => { el.style.display = 'none'; });
      document.querySelector('.harness_hide').style.display = 'none';
      showMoreHarnessButton.style.display = 'block';
    });
  }

  // converting place address
  const showMoreAddressPlaceButton = document.querySelector('.converting-place-detail-address-button_show');
  if (showMoreAddressPlaceButton) {
    showMoreAddressPlaceButton.addEventListener('click', (e) => {
      const addressesBlock = e.currentTarget.closest('.converting-place-detail');
      if (addressesBlock) {
        const hiddenEls = addressesBlock.querySelectorAll('.converting-place-address-block_hidden');
        for (let i = 0; i < hiddenEls.length; i += 1) {
          hiddenEls[i].style.display = 'block';
        }
        addressesBlock.querySelector('.converting-place-detail-address-button_hidden').style.display = 'block';
        addressesBlock.querySelector('.converting-place-detail-address-button_show').style.display = 'none';
      }
    });
    const hiddenAddressPlaceButton = document.querySelector('.converting-place-detail-address-button_hidden');
    hiddenAddressPlaceButton.addEventListener('click', (e) => {
      const addressesBlock = e.currentTarget.closest('.converting-place-detail');
      if (addressesBlock) {
        const hiddenEls = addressesBlock.querySelectorAll('.converting-place-address-block_hidden');
        for (let i = 0; i < hiddenEls.length; i += 1) {
          hiddenEls[i].style.display = 'none';
        }
        addressesBlock.querySelector('.converting-place-detail-address-button_hidden').style.display = 'none';
        addressesBlock.querySelector('.converting-place-detail-address-button_show').style.display = 'block';
      }
    });
  }

  // partners buttons block
  function clickTicketButton() {
    const dropdownBlock = document.getElementById('ticket-services-list-dropdown');
    const buttons = document.querySelectorAll('.buy-ticket');

    if (dropdownBlock) {
      buttons.forEach((button) => button.classList.add('button-disabled'));
      const labels = dropdownBlock.getElementsByTagName('label');
      document.getElementById('services-dropdown__close').addEventListener('click', () => {
        document.querySelector('body').click();
        buttons.forEach((button) => button.classList.remove('button-disabled'));
      });
      for (let i = 0; i < labels.length; i++) {
        labels[i].addEventListener('click', (event) => {
          const block = event.currentTarget.closest('.pather-radio__block');
          const buttonTicket = block.querySelector('a');
          document.querySelector('.buy-button__block').querySelectorAll('a').forEach((e) => e.remove());
          document.querySelector('.buy-button__block').querySelector('button').style.display = 'none';
          document.querySelector('.buy-button__block').append(buttonTicket.cloneNode(true));
          document.querySelector('.buy-button__block').querySelector('a').style.display = 'block';
        });
        if (labels[i].closest('.pather-radio__block').querySelector('input').checked && !document.querySelector('.buy-button__block').querySelector('a')) {
          const block = labels[i].closest('.pather-radio__block').closest('.pather-radio__block');
          const buttonTicket = block.querySelector('a');
          document.querySelector('.buy-button__block').querySelector('button').style.display = 'none';
          document.querySelector('.buy-button__block').append(buttonTicket.cloneNode(true));
          document.querySelector('.buy-button__block').querySelector('a').style.display = 'block';
        }
      }
    } else {
      buttons.forEach((button) => button.classList.remove('button-disabled'));
    }
  }

  if (q('#ticket-services-dropdown-button-big')) {
    document.getElementById('ticket-services-dropdown-button-big').addEventListener('click', () => {
      setTimeout(() => clickTicketButton());
    });
  }

  if (q('#ticket-services-dropdown-button-small')) {
    document.getElementById('ticket-services-dropdown-button-small').addEventListener('click', () => {
      setTimeout(() => clickTicketButton());
    });
  }

  if (q('.ticket-services-dropdown-button')) {
    const buttons = document.querySelectorAll('.ticket-services-dropdown-button');
    buttons.forEach((button) => button.addEventListener('click', () => {
      setTimeout(() => clickTicketButton());
    }));
  }

  /* ----------------------- Editors choice slider ------------------------------------ */
  const editorsChoiceSlider = q('#editors_choice_slider');
  const editorsChoiceSliderAllowedLocations = ['msk', 'spb', 'ekb', 'kzn', 'nnv'];
  if (editorsChoiceSlider && editorsChoiceSliderAllowedLocations.indexOf(kudago.location) !== -1
      && !kudago.isConvertingPageview
      && !(kudago.page === 'activity' && kudago.tagSlug === 'lifestyle')
  ) {
    editorsChoiceSlider.style.display = 'block';
    const swiperElement = document.getElementById('editors_choice_slider_wrapper');
    const sliderItems = document.querySelectorAll('#editors_choice_slider_wrapper .slide-item');
    for (let i = 0; i < sliderItems.length; i++) {
      sliderItems[i].dataset.background = sliderItems[i].dataset.background_mobile;
    }
    new Swiper(swiperElement, {
      loop: true,
      speed: 200,
      slidesPerView: 'auto',
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true,
      },
      pagination: {
        el: '.editors-choice-slider-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: q('#editors_choice_slider .nav-right'),
        prevEl: q('#editors_choice_slider .nav-left'),
      },
    });
  }

  /* ------------------------ Featured items & sliders ---------------------------- */

  function initSwipers() {
    q.all('.swiper-container:not(.questSchedule-content)').forEach((swiperElement) => {
      const activeClass = 'swiper-container-active';
      const slides = q.all('.swiper-slide', swiperElement);

      // if there is one picture, then the slider
      // library does not start and the data-src attribute for images is replaced with src
      if (slides.length < 2) {
        for (let i = 0; i < slides.length; i++) {
          const image = slides[i].getElementsByTagName('img');
          if (image.length > 0) {
            if (image[0].hasAttribute('data-src')) {
              const datasrc = image[0].getAttribute('data-src');
              if (datasrc !== null && !image[0].hasAttribute('src')) {
                const src = document.createAttribute('src');
                src.value = datasrc;
                image[0].setAttributeNode(src);
                image[0].removeAttribute('datasrc');
              }
            }
          }
        }
        return;
      }

      if (swiperElement.classList.contains(activeClass)) {
        return;
      }

      swiperElement.classList.add(activeClass);

      const options = {
        mode: 'horizontal',
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
      };

      if (swiperElement.classList.contains('post-preview')
      || swiperElement.classList.contains('contentSlider')) {
        const swiperPager = q('.post-preview-pagination, .contentSlider-pagination', swiperElement);
        if (swiperPager) {
          options.pagination = {
            el: swiperPager,
          };
        }
      }

      if (swiperElement.classList.contains('featured-slider-container')) {
        const swiperPager = q('.featured-preview-pagination, .contentSlider-pagination', swiperElement);
        if (swiperPager) {
          options.pagination = {
            el: swiperPager,
          };
        }
      }

      const swiper = new Swiper(swiperElement, options);

      swiper.on('touchEnd', () => {
        emit(swiper.el, 'swiper-changed', null, true);
      });
    });

    makeLinks();
  }

  initSwipers();

  /* --------------------------- Address lists of list items -------------------- */
  q.all('.post-list-item-info').forEach((el) => {
    const addressList = new ListItemAddressList(el);
    addressList.init();
  });

  /* ------------------------- ImageLazyLoader ------------------- */
  // eslint-disable-next-line no-unused-vars
  const imageLazyLoader = new ImageLazyLoader();
  const refreshLazyImages = () => imageLazyLoader.refresh();

  /* ------------------------- Movie Date Tabs Swiper --------------*/

  const initTabsSwiper = () => {
    const options = {
      mode: 'horizontal',
      loop: false,
      slidesPerColumnFill: 'row',
      slidesPerView: 3,
      navigation: {
        nextEl: '.tabsSwiper-button-next',
        prevEl: '.tabsSwiper-button-prev',
      },
    };
    return new Swiper(q('.swiper-container--tabs'), options);
  };
  initTabsSwiper();

  /* --------------------------- Social buttons -------------------- */
  likely.initiate();

  /* ------------------- Init quizes ------------------- */
  if (window.quizConfig) {
    q.all('.js-quizStart').forEach((i) => on(i, 'click', () => {
      emit(document.body, 'test-start', null, true);
      q.all('.js-hideForQuiz').forEach((j) => j.setAttribute('hidden', 'hidden'));
    }));
    if (new URLSearchParams(new URL(window.location).search).has('result')) {
      q.all('.js-hideForQuiz').forEach((j) => j.setAttribute('hidden', 'hidden'));
    }

    const container = q('#quiz-container');
    ReactDOM.render(<Quiz config={window.quizConfig} />, container);
  }

  /* --------------------------- Inline svg images -------------------------------- */
  const svgImgSelector = 'img[src$=".svg"]:not(.mobile-not-svg-inject)';

  inlineSvg(svgImgSelector);

  const feedEl = q('.page-feed');
  if (feedEl) {
    on(feedEl, 'loaded', () => inlineSvg(svgImgSelector));
  }

  /* ----------------------------- Navigation ------------------------------------ */
  // For user leaving mix to the item element
  delegate(q('.page-mix'), 'click', '.post-title-link, .post-image-link, .post-comments', (e) => {
    // ignore city mix
    if (q('.page-city')) return;

    const mixUrl = q('.page-header-link').pathname;
    const mixName = q('.page-header-link').textContent;
    const itemUrl = e.target.pathname;

    // Set `mix <-> item` association for an hour
    const { navCache } = window;
    const { navCacheNames } = window;

    navCache[itemUrl] = mixUrl;
    navCacheNames[itemUrl] = mixName;

    sessionStorage.setItem('nav-cache', JSON.stringify(navCache));
    sessionStorage.setItem('nav-cache-names', JSON.stringify(navCacheNames));
    sessionStorage.setItem('nav-cache-expiry', +new Date() + 3600 * 1000);
  });

  /* ------------------------------ City dropdown --------------------------------- */
  q.all('.city-select').forEach((el) => {
    on(el, 'change', function () {
      // utterly go to the new location
      window.location = this.value;
    });
  });

  /* ------------------------------ Cookie --------------------------------- */
  if (!JSON.parse(localStorage.getItem('cookie-permission'))) {
    document.querySelector('.cookie-warning').style.visibility = 'visible';
  }

  document.querySelector('.cookie-warning__button').addEventListener('click', () => {
    localStorage.setItem('cookie-permission', true);
    document.querySelector('.cookie-warning').style.visibility = 'hidden';
  });

  /* ----------------------- Load user zone --------------------------- */

  if (kudago.user.isAuthenticated) {
    const container = q('.user-zone-container');
    if (container) {
      ajax({
        url: '/widgets/user-zone/',
        success: (html) => {
          container.innerHTML = html;
        },
      });
    }
  } else {
    const loginElement = q('#login');
    if (loginElement) {
      loginElement.removeAttribute('hidden');
    }
  }

  /* ------------------------------ Filters -------------------------------------- */
  q.all('.filter-select').forEach((el) => {
    on(el, 'change', function () {
      window.location = this.value;
    });
  });

  /* -------------------------------- Likes ------------------------------------- */
  const { Like, DynamicLike } = require('./components/like');
  class MobileLike extends Like {
    openLoginDialog() {
      scrollToEl('#login', { pulse: true });
    }
  }

  delegate(document.body, 'click', '.js-likes', (e) => {
    const like = new MobileLike({
      element: e.delegateTarget,
    });
    like.toggle();
  });
  q.all('.js-dynamic-likes').forEach((i) => new DynamicLike(i));

  /* -------------------- Price list order buttons -------------------- */

  q.all('.priceList-button').forEach((button) => {
    on(button, 'click', () => {
      if (document.body.classList.contains('body--priceListPopup')) {
        const formClone = q('#contactForm').cloneNode(true);

        dialog(null, formClone)
          .effect('fade')
          .overlay()
          .fixed()
          .closable()
          .escapable()
          .show();
      } else {
        scrollToEl('#contactForm');
      }

      const item = button.closest('.priceList-item');
      const titleEl = q('.priceList-title', item);
      const title = titleEl.textContent;

      const container = item.closest('.priceList-container');
      const suffix = container.getAttribute('data-location-suffix') || '';

      q.all('#contactForm [name="message"]').forEach((i) => { i.value = `${title} ${suffix}`; });
    });
  });

  /* --------------------------- Comments --------------------------------- */

  const { Comment } = require('./components/comments');
  const { CommentsList } = require('./components/comments');
  const { CommentsForm } = require('./components/comments');

  class MobileCommentsForm extends CommentsForm {
    loginHandler() {
      scrollToEl('#login', { pulse: true });
    }
  }

  // item page comments

  const commentsListEl = q('.comments-list');

  if (commentsListEl) {
    const commentsList = new CommentsList({
      el: commentsListEl,
      initialLoad: true,
    });

    const repliesForm = new MobileCommentsForm({
      el: q('#replies-form'),
      hideOnSubmit: true,
    });

    const commentsForm = new MobileCommentsForm({
      el: q('#comments-form'),
      prepend: true,
      commentsList,
    });

    Comment.setRepliesForm(repliesForm);

    repliesForm.restore();
    commentsForm.restore();
  }

  const profileCommentsListEl = q('#profile-comments-list');
  if (profileCommentsListEl) {
    new CommentsList({
      el: profileCommentsListEl,
    });
  }

  if (commentsListEl) {
    const hasStoredComment = sessionStorage.getItem('savedComment');
    if (hasStoredComment && window.location.hash == '#comments') {
      q('#comments').removeAttribute('hidden');
    }

    delegate(document.body, 'click', 'label.post-comments', () => {
      q('#comments').style.display = 'block';
    });
  }

  const commentsSubmit = q('.comments-reply-submit-status');
  if (commentsSubmit) {
    if (!kudago.user.isAuthenticated) {
      commentsSubmit.classList.toggle('comments-reply-submit-status', 'comments-reply-submit-inactive');
    }
  }

  /* ----------------- Special lists / news widgets -------------------------- */
  const SpecialWidget = require('./components/special-widgets-loader');

  const specialBlocks = ['lists', 'soon', 'lists-mockup', 'soon-mockup'];
  const itemSpecialSelector = specialBlocks.map((b) => `.item-special-${b}-widget`).join(', ');
  const mixSpecialSelector = specialBlocks.map((b) => `.special-${b}-widget`).join(', ');
  const specialWidgets = q.all(`${itemSpecialSelector}, ${mixSpecialSelector}, .eat-nearby-widget`);

  specialWidgets.forEach((el) => new SpecialWidget({ el }));
  on(document, 'special-widgets-loaded', () => {
    specialWidgets.forEach((el) => {
      const soonSwiperWrapper = el.closest('.soon-widget-wrapper');
      if (soonSwiperWrapper && el.innerHTML.trim()) {
        soonSwiperWrapper.removeAttribute('hidden');
      }
    });
    initSwipers();
  });

  /* ----------------- converting events loading widgets -------------------------- */
  const ConvertinEventgWidget = require('./components/converting-events-widget-loader');
  const convertingEventsWidgetContainers = q.all('.converting-events-list');

  convertingEventsWidgetContainers.forEach((widget) => {
    // eslint-disable-next-line no-new
    new ConvertinEventgWidget({
      el: widget,
    });
  });

  /* ----------------- converting places loading widgets -------------------------- */
  const ConvertingPlacesWidget = require('./components/converting-places-widget-loader');
  const convertingPlacesWidgetContainers = q.all('.converting-places-list');

  convertingPlacesWidgetContainers.forEach((widget) => {
    new ConvertingPlacesWidget({
      el: widget,
    });
  });

  /** Init all textareas as autosize */
  autosize(q.all('textarea'));
  const loadMoreButton = q('.loadMoreButton');
  if (loadMoreButton) {
    const loadMoreEvents = new CustomEvent('loadMoreEvents', { bubbles: true });
    loadMoreButton.addEventListener('click', () => loadMoreButton.dispatchEvent(loadMoreEvents));
    // eslint-disable-next-line no-return-assign
    document.addEventListener('hideLoadMoreEventsButton', () => (loadMoreButton.hidden = true));
    const EventsListNew = require('./components/events-list-react');
    ReactDOM.render(<EventsListNew />, q('#eventsListWrapper-showMore'));
  }

  const {
    sendCountersView,
    bindCountersClick,
  } = require('./components/external-counters');
  bindCountersClick();
  sendCountersView();

  /* Flatpages feedback form */
  feedbackFormHendler();

  function setFeedPingData() {
    q.all('.page-feed .post').forEach((item, index) => {
      if (!item.hasAttribute('data-ping-position')) {
        item.setAttribute('data-ping-position', index + 1);
      }
    });
  }

  /* dates lists hiding */

  const DatesList = require('./components/mobile/dates-list');
  q.all('.datesList').forEach((item) => new DatesList({ element: item }));

  /* stext hiding */

  const Stext = require('./components/mobile/stext');
  const stextCityContainer = q('.stext');
  new Stext({ element: stextCityContainer });

  /* submit form without unfilled fields */
  const submitWithoutEmptyValues = (form) => {
    if (!form) return;
    const fd = new FormData(form);
    const formDataObject = fromPairs([...fd.entries()]);
    // eslint-disable-next-line no-restricted-syntax
    for (const key in formDataObject) {
      if (!formDataObject[key] || formDataObject[key] === 'undefined') {
        delete formDataObject[key];
      }
    }
    // eslint-disable-next-line consistent-return
    queryString.stringify(formDataObject);
    window.location.search = `?${queryString.stringify(formDataObject)}`;
  };

  /* ----------------------- React DatePicker init --------------*/
  const DatePicker = require('./components/datepicker');
  const datePickerContainer = q('#react-date-picker');
  const hiddenDateInput = q('.filter-date-input');

  if (datePickerContainer && hiddenDateInput) {
    const lastChoosenDate = queryString.parse(window.location.search).date;
    hiddenDateInput.value = lastChoosenDate;

    ReactDOM.render(<DatePicker isMobile />, datePickerContainer);
    const onCalendarSelect = (e) => {
      const form = q('.mix-filters-form');
      hiddenDateInput.value = e.detail.date;
      submitWithoutEmptyValues(form);
    };
    datePickerContainer.addEventListener('select', onCalendarSelect);
  }

  /* Filters menu */
  const filtersMenu = q('.mix-filters-menu-container');
  if (filtersMenu) {
    const filtersForm = q('.mix-filters-form', filtersMenu);
    const filterSubmit = q('.mix-filters-menu-submit', filtersMenu);
    const filters = q.all('.filter-item', filtersMenu);
    const filtersCounter = q.all('.chosen-filters');

    const resetAnotherFilters = (e) => {
      const restaurantsFilters = ['feature', 'cuisine', 'subway'];
      const knowledgeFilters = ['type', 'subject'];
      const barsFilters = ['feature'];
      const cinemasFilters = ['feature', 'subway'];
      let filtersItems = [];

      if (kudago.page === 'knowledge') {
        filtersItems = knowledgeFilters;
      } else if (kudago.page === 'restaurants') {
        filtersItems = restaurantsFilters;
      } else if (kudago.page === 'bars') {
        filtersItems = barsFilters;
      } else if (kudago.page === 'cinemas') {
        filtersItems = cinemasFilters;
      }

      if (filtersItems.indexOf(e.currentTarget.name) !== -1) {
        const filtersAnother = filtersItems.filter((item) => item !== e.currentTarget.name);
        filters.forEach((filter) => {
          if (filtersAnother.indexOf(filter.name) !== -1) {
            if (filter.name === 'subway') {
              filter.selectedIndex = 0;
              for (let i = 0; i < filter.options.length; i++) {
                filter.options[i].selected = false;
              }
            } else {
              filter.selectedIndex = 1;
            }
          }
        });
      }
    };
    if (kudago.page === 'knowledge' || kudago.page === 'restaurants') {
      filters.forEach((filter) => {
        filter.addEventListener('change', resetAnotherFilters);
      });
    }

    const updateSelectedFilters = () => {
      const count = filters.filter((i) => (
        i.selected || i.selectedOptions || i.checked || (i.type == 'date' && i.value)
      )).length;
      if (count) {
        filtersCounter.forEach((item) => {
          item.textContent = count;
        });
      } else {
        filtersCounter.forEach((item) => {
          item.textContent = '';
        });
      }
    };

    filterSubmit.addEventListener('click', (e) => {
      e.preventDefault();
      submitWithoutEmptyValues(filtersForm);
    });
    updateSelectedFilters();
    on(filtersMenu, 'change', () => updateSelectedFilters());

    q.all('.mix-filters-menu-overlay, .mix-filters-menu-header').forEach((item) => {
      on(item, 'click', closeFiltersMenu);
    });

    q.all('.mix-filters-menu-item', filtersMenu).forEach((label) => {
      const title = q('.mix-filters-menu-label-title', label);
      const titleWidth = title.clientWidth + 20;
      const select = q('.facet-items', label);
      if (select) {
        const options = q.all('optgroup, option', select);
        const optionsLengths = options.map((item) => {
          const text = item.getAttribute('label') || item.innerText.trim();
          return text.length;
        });
        // we summ select title width and the select value width and compare
        // the summ with filter form length to decide whether to bring
        // select value on the next line or not;
        // 8.6 is empirically calculated value for transforming text length
        // into pixels because optgroup hasn't width
        const maxOptionWidth = Math.max(...optionsLengths) * 8.6;
        if (maxOptionWidth + titleWidth > filtersMenu.clientWidth) {
          label.classList.add('mix-filters-wide');
        } else {
          select.style.paddingLeft = `${titleWidth}px`;
        }
      }
    });
  }

  const filtersMenuButton = q('.mix-filters-button._filters');
  const bogusState = 'such history';

  function openFiltersMenu() {
    document.body.classList.add('body--filtersOpen');
    // eslint-disable-next-line no-restricted-globals
    if (history.state !== bogusState) {
      // put something to be able to catch "go backwards" history event and close menu instead
      // eslint-disable-next-line no-restricted-globals
      history.pushState(bogusState, null, '');
    }
  }

  function closeFiltersMenu() {
    document.body.classList.remove('body--filtersOpen');
  }

  on(filtersMenuButton, 'click', openFiltersMenu);
  const isFiltersMenuOpen = () => document.body.classList.contains('body--filtersOpen');

  on(window, 'popstate', (event) => {
    if (isFiltersMenuOpen()) {
      event.preventDefault();
      closeFiltersMenu();
    }
  });

  q.all('.order-by-proximity').forEach((item) => {
    on(item, 'click', toggleProximityOrdering);
  });

  function toggleProximityOrdering() {
    const query = queryString.parse(window.location.search);
    if (query.order == 'proximity') {
      delete query.order;
      window.location.search = queryString.stringify(query);
      return;
    }
    query.order = 'proximity';
    return getUserCoords().then((coords) => {
      if (coords) {
        cookie.set('coords', `${coords.longitude},${coords.latitude}`);
      }
      window.location.search = queryString.stringify(query);
    });
  }

  const geoCentrMessageContainer = q('.defaultGeoCentr-container');
  if (geoCentrMessageContainer) {
    delegate(document.body, 'click', geoCentrMessageContainer, () => {
      geoCentrMessageContainer.style.display = 'none';
    });

    scrollToEl('#filters', { offset: 150 });
  }

  /* -------------- Replace some neutral elems to links ------------ */

  function makeLinks() {
    const { makeLink } = window;
    if (makeLink) {
      q.all('[data-future-href]').forEach((i) => makeLink(i));
    }
  }
  makeLinks();

  /* -------------- Infinite item feed initial load ------------ */
  const itemFeedContainer = q('.infiniteFeed-container');

  if (itemFeedContainer) {
    const mixNames = kudago && kudago.isItemPage && kudago.itemPageNames;
    if (mixNames.length) {
      const ItemFeedLoader = require('./components/item-feed');
      const { Item } = require('./components/feed/item');
      const locationSlug = window._metricsConfig.location.slug;
      const feedUrl = mixNames[0] === 'index' ? `/${locationSlug}/` : `/${locationSlug}/${mixNames[0]}/`;
      new ItemFeedLoader(
        new Item(),
        itemFeedContainer,
        feedUrl,
        [makeLinks, refreshLazyImages],
      ).render();
    }
  }

  setFeedPingData();

  /* load more button */

  const { SearchFeedLoader, FeedLoader } = require('./components/mobile/load-more');

  {
    const feed = q('.page-feed, .search-results-feed, .infiniteFeed-items');
    if (feed) {
      const options = {
        feed,
        buttons: q.all('.load-more-button', feed.parentNode),
        onRender() {
          sendCountersView();
          setFeedPingData();
          makeLinks();
        },
        refreshLazyImages,
      };

      if (q('.search-results-feed')) {
        new SearchFeedLoader(options);
      } else {
        new FeedLoader(options);
      }
    }
  }

  /* contests */
  const Countdown = require('./components/countdown');
  q.all('.countdown-contest').forEach((element) => {
    const ending = element.getAttribute('data-date-ending') * 1000;
    const countdown = new Countdown(element, {
      date: ending,
    });

    countdown.on('expire', () => {
      element.innerHTML = _('Contest has finished. Winners are being chosen');
    });
  });

  /* -------------- Messages deletion ------------- */
  delegate(document.body, 'click', '.messages-close', (e) => {
    const message = e.delegateTarget.closest('.messages-item');
    message.parentNode.removeChild(message);
  });

  /* ------------- rel="noopener" ------------- */
  // see https://jakearchibald.com/2016/performance-benefits-of-rel-noopener/
  q.all('[target="_blank"]').forEach((i) => {
    const currentRel = i.getAttribute('rel') || '';
    i.setAttribute('rel', `${currentRel} noopener`);
  });

  /* -------------- Add CSRF token to POST forms -------------- */
  const CSRFTokenHandler = require('./components/csrf-handler');

  const csrfHandler = new CSRFTokenHandler();
  csrfHandler.run();

  /* --------------------------- Surveys --------------------------------- */
  // wrap mix survey in order to have the same container with desktop surveys
  // it's a temporary decision and mix surveys have to be redisign to ajax
  // loading too
  if (window._metricsConfig && window._metricsConfig.page) {
    const surveyWidget = q('.surveyWidget');
    const surveyContainer = q('.survey-container');
    if (surveyWidget && !surveyContainer) {
      const surveyWidgetWrapper = document.createElement('div');
      surveyWidgetWrapper.classList.add('survey-container', 'survey-container-mix');
      q('.page-feed').insertBefore(surveyWidgetWrapper, surveyWidget);
      surveyWidgetWrapper.appendChild(surveyWidget);
    }
  }

  const submitSurvey = (e) => {
    const target = e.delegateTarget;
    const surveyContainer = target.closest('.survey-container');
    const surveyThanks = q('.surveyThanks', surveyContainer);
    const surveyQuestion = q('.surveyQuestion', surveyContainer);
    const optionId = target.getAttribute('data-option-id');
    const surveyId = q('.surveyWidget', surveyContainer).getAttribute('data-survey-id');
    const secondSurvey = q('.surveyThanks-secondSurvey', surveyContainer);

    ajax({
      type: 'POST',
      headers: {
        'X-CSRFToken': cookie.get('csrftoken'),
      },
      data: {
        survey: surveyId,
        option: optionId,
      },
      url: '/surveys/respond/',
      timeout: 5000,
      success: () => {
        surveyQuestion.setAttribute('hidden', 'hidden');
        surveyThanks.removeAttribute('hidden');

        if (surveyContainer.classList.contains('alreadySeen')) {
          secondSurvey.setAttribute('hidden', 'hidden');
          q('.surveyThanks-button--general', surveyContainer).removeAttribute('hidden');
          q('.surveyThanks-tagline--intro', surveyContainer).setAttribute('hidden', 'hidden');
        } else {
          surveyContainer.classList.add('alreadySeen');
          secondSurvey.removeAttribute('hidden');
        }
      },
    });
  };

  delegate(document.body, 'change', '.surveyOption', submitSurvey);

  /* -------- Load aside surveys ------------ */

  const container = q('.survey-container');
  const surveyPages = window._metricsConfig && window._metricsConfig.mixes;

  const loadSurvey = () => {
    ajax({
      url: '/surveys/widgets/',
      data: {
        location: kudago.location,
        pages: surveyPages.join(','),
      },
      success: (html) => {
        if (html) {
          container.innerHTML = html;
        } else if (container.classList.contains('alreadySeen')) {
          const sorryTagline = `<div class="surveyThanks-tagline surveyThanks-tagline--sorry">
                                Ой! Кажется, все вопросы закончились(</div>`;
          container.innerHTML = sorryTagline;
        }
      },
    });
  };

  if (container && !container.classList.contains('survey-container-mix')) {
    loadSurvey();
  }
  delegate(document.body, 'click', '.surveyThanks-button', loadSurvey);

  /* ---------------- New year quiz --------------- */
  const NewYearTest = require('./components/ny-test');
  const newYearBlock = q('.nyt');
  if (newYearBlock) {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '741264092565677',
        version: 'v2.4',
        status: true,
        cookie: true,
        xfbml: false,
      });
    };

    /* eslint-disable */

    // --------------------------GooglePlus init
    const po = document.createElement('script');
    po.type = 'text/javascript';
    po.async = true;
    po.src = 'https://apis.google.com/js/plusone.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(po, s);


    /* eslint-enable */
    new NewYearTest({
      element: newYearBlock,
      questions: window.newYearQuestions,
    });

    q.all('.login-link').forEach((link) => {
      on(link, 'click', (e) => {
        e.preventDefault();
        scrollToEl('#login', { pulse: true });
      });
    });
  }
});

/* ---------------- United Buttons --------------- */

const multiPhones = q('.multiPhones');

if (multiPhones) {
  const body = q(document.body);
  delegate(body, 'click', '.post-phone-multi', () => {
    multiPhones.classList.remove('multiPhones--hidden');
    setBodyFixed(true);
  });

  delegate(body, 'click', '.multiPhones-bg', () => {
    multiPhones.classList.add('multiPhones--hidden');
    setBodyFixed(false);
  });
}

/* ----------------------- JS Approve email ------------------------------------ */

const emailBar = q('.approve-email-bar-js');

if (emailBar
    && window.kudago.user
    && window.kudago.user.isAuthenticated
    && !window.kudago.user.isConfirmed) {
  css(emailBar, {
    display: 'block',
  });
}

/* --------------------------- Tabs ---------------------------------- */
initTabs();

/* --------------------------- Quest Schedules -------------------------------- */
const { setQuestSlider, questBooking } = require('./components/quest-schedules');

setQuestSlider('.questSchedule-content');
questBooking('.questSchedule-card:not(.questSchedule-card--disabled)', { width: '100%' });

/* ------------------- Movie schedules -------------------- */
const { initMovieScheduler } = require('./components/movie-scheduler');

const schedulesContainer = q('.schedule-tables');
if (schedulesContainer) {
  initMovieScheduler(schedulesContainer);
}

/* Service worker */

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
}

window.addEventListener('load', () => {
  function handleNetworkChange() {
    if (navigator.onLine) {
      document.body.classList.remove('user-offline');
    } else {
      document.body.classList.add('user-offline');
    }
  }
  handleNetworkChange(); // initial check
  window.addEventListener('online', handleNetworkChange);
  window.addEventListener('offline', handleNetworkChange);
});
/* ------- Show / hide phone numbers in place and event items -----------*/
require('./components/multi-addresses');

/* -------------------- Init dropdowns ----------------------------- */
require('./components/dropdowns');

/* ----------------------- Sticky panel on converting events --------------------------- */
stickybits('.navbar--sticky');

const subscriptionBlock = q('#subscription-block');
if (subscriptionBlock) {
  const subscribe = new Subscription();
  subscribe.start();
}

document.addEventListener('DOMContentLoaded', startScriptForAdvertButton);

function startScriptForAdvertButton() {
  const advertButton = q('.advert-button');
  if (advertButton) {
    const AdButton = new AdvertButton();
    AdButton.start();
  }
}

// rating

const pageRating = new PageRating();
pageRating.start();

/* ------------------- Init respondent_session_id ------------------- */

let respondent_session_id = null;
if (localStorage.getItem('respondent_session_id')) {
  respondent_session_id = localStorage.getItem('respondent_session_id');
} else {
  respondent_session_id = uuidv4();
  localStorage.setItem('respondent_session_id', respondent_session_id);
}

/* ------------------- Init quizes ------------------- */
const miniQuizes = document.querySelectorAll('.mini-quiz-item');

for (let i = 0; i < miniQuizes.length; i++) {
  const miniQuiz = miniQuizes[i];
  const id = parseInt(miniQuiz.className.match(/\d+/), 10);

  ReactDOM.render(<MiniQuiz id={id} sessionId={respondent_session_id} isMobile />, miniQuiz);
}

const miniQuestions = document.querySelectorAll('.mini-question-item');

for (let i = 0; i < miniQuestions.length; i++) {
  const miniQuestion = miniQuestions[i];
  const id = parseInt(miniQuestion.className.match(/\d+/), 10);

  // eslint-disable-next-line max-len
  ReactDOM.render(<MiniQuestion id={id} sessionId={respondent_session_id} isMobile />, miniQuestion);
}
